import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'
import { ProductSiteMetadataQuery } from 'generated/types/gatsby'
import Header from '../header/Header'
import Search from '../search/Search'
import { Footer } from '../footer/Footer'
import { Scrollbars } from 'react-custom-scrollbars'
import './product-layout.scss'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { TopNav } from '../top-nav/TopNav'
import { LeftNav } from '../left-nav/LeftNav'
import { WindowLocation } from '@reach/router'

interface ProductLayoutProps {
  readonly children?: React.ReactNode | readonly React.ReactNode[]
  readonly productName: string
  readonly location?: WindowLocation
}

export const ProductLayout = ({ children, productName, location }: ProductLayoutProps) => {
  // Get product links scroll container ref
  const scrollbar = React.createRef<Scrollbars>()
  useEffect(() => {
    if (scrollbar.current && location?.hash) {
      const offsetTop: number =
        (document.querySelector(`${location.hash}`) as HTMLElement)?.offsetTop || 8
      // scroll to menu item with hash. 8px - default padding
      scrollbar.current.scrollTop(offsetTop - 8)
    }
  })

  const data = useStaticQuery<ProductSiteMetadataQuery>(graphql`
    query ProductSiteMetadata {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  const breakpoints = useBreakpoint()
  const [menuState, setMenuState] = useState(false)

  return (
    <main className={`la-page${menuState ? ' la-page_has-active-menu' : ''}`}>
      <Helmet
        titleTemplate={`%s - ${data.site.siteMetadata.title}`}
        defaultTitle={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content: data.site.siteMetadata.description,
          },
          {
            name: 'keywords',
            content: 'LiveAction, LiveNX, Omnipeek, Documentation',
          },
        ]}
      />

      <Header
        title={data.site.siteMetadata.title}
        toggleMenu={() => {
          setMenuState(menuState === undefined ? true : !menuState)
        }}
      >
        <Search productName={productName} autoHeightMax={'50vh'} />
      </Header>

      {!(breakpoints.sm || (breakpoints.md && breakpoints.portrait)) ? <TopNav /> : null}

      <div className={'la-page-body'}>
        <Scrollbars className="la-page-body__main la-scrollbar" ref={scrollbar}>
          <div className="la-page-body__main-content-wrapper">
            <div className="la-page-body__main-breadcrumbs la-breadcrumbs">
              <span className="la-breadcrumbs-title">{productName}</span>
            </div>
            <div className="la-page-body__main-content">{children}</div>
          </div>
          <Footer />
        </Scrollbars>
      </div>

      <button
        className="la-menu-overlay"
        onClick={() => {
          setMenuState(false)
        }}
      />

      {breakpoints.sm || breakpoints.md ? (
        <Scrollbars className="la-left-nav-wrapper la-scrollbar">
          <LeftNav />
        </Scrollbars>
      ) : null}
    </main>
  )
}
